




import Vue from 'vue';
import { createNamespacedHelpers } from 'vuex';
import PageFetchHook from '@/components/mixins/PageFetchHook';
import PageLeftHook from '@/components/mixins/PageLeftHook.vue';
import store from '@/store';
import * as CvSectionDateStoreEdit from '@/store/modules/cvSectionDateEdit';
import EditContainer from '@/containers/cv-section-date/edit.vue';

const { mapGetters } = createNamespacedHelpers(
  CvSectionDateStoreEdit.namespace
);

const fetch = async params => {
  const { cv_id, id } = params;
  await store.dispatch(
    CvSectionDateStoreEdit.GetCvSectionDate.namespaced({
      params: { cv_id, id },
    })
  );
};

export default Vue.extend({
  components: {
    EditContainer,
  },
  mixins: [PageLeftHook, PageFetchHook(fetch)],
  data() {
    return {
      storeList: [CvSectionDateStoreEdit],
    };
  },
  computed: {
    ...mapGetters(['cvSectionDate']),
  },
});
